<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5" >
              <h6 class="manage-boder pt-2 font1 font-bold1"> <a class="decoration" > Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Service </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/"> Settings   </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/mserviceadvisor/index"> Manage Service Advisor   </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Create Service Advisor </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div class="container-fluid">
                    <div class="card custom_bdr_rds">
                        <div style="background-color: #f2f3f4; " class="card-body custom_bdr_rds">


                    <form @submit.prevent="SaveProduct()" >

<div class="row">
 
  
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Advisor Name </label>
            <input  v-model="all_data.name"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Area </label>
            <input  v-model="all_data.area"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Type </label>
            <v-select label="label"  v-model="all_data.type" :options="types" ></v-select>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Contact No</label>
          
            <input  v-model="all_data.contact_no"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
</div>

















   

    <div style="border-bottom: 0px; padding-top: 0px;background-color: #f2f3f4;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  " >
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def">Update</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
           
            </div>
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
            this.loadData();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
           
        total:0,
        selectedOption: null, // Store the selected option
       

        brands:[],
        suppliers:[],
        vehicles:[],
        Locations:[],
        all_data:{},
       
      
        types: [
            { label: 'Spare Parts', value: '1' },
            { label: 'Batteries', value: '3' },
            { label: 'Vehicle', value: '2' },
            { label: 'Service', value: '4' },
            // Add more options as needed
        ],
        
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {
    


            async loadData() {
     
     
       try {
         const { data} = await  axios.get('/mserviceadvisor/loadupdate?id='+this.id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.all_data = data.all_data;
        //   this.suppliers = data.suppliers;
        //   this.vehicles = data.vehicles;
        //   this.Locations = data.Locations;
         
         
       } catch (error) {
         console.log(error.response);
       }
     },

       

    async SaveProduct() {
       
      console.log(this.all_data);
   
    console.log("amila");
       try {
         const { data} = await  axios.post('/mserviceadvisor/update',{userid:this.userid,all_data:this.all_data,id:this.id},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/mservicetechnician/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },
       

     

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    